/**
 * IdleStateContext
 * 
 * Global context for managing idle state across the application
 * Requirements: 19.5
 */

import { createContext, useContext, type ReactNode } from 'react';
import { useIdleState } from '../hooks/useIdleState';

interface IdleStateContextValue {
  isIdle: boolean;
}

const IdleStateContext = createContext<IdleStateContextValue | undefined>(undefined);

export function IdleStateProvider({ children }: { children: ReactNode }) {
  const { isIdle } = useIdleState({
    idleTimeout: 5 * 60 * 1000, // 5 minutes
    enabled: true,
    onIdle: () => {
      console.log('Application is now idle - resources will be cleaned up');
    },
    onActive: () => {
      console.log('Application is now active');
    },
  });

  return (
    <IdleStateContext.Provider value={{ isIdle }}>
      {children}
    </IdleStateContext.Provider>
  );
}

export function useIdleStateContext() {
  const context = useContext(IdleStateContext);
  if (context === undefined) {
    throw new Error('useIdleStateContext must be used within IdleStateProvider');
  }
  return context;
}
